import { FrIconClassName } from '@codegouvfr/react-dsfr';
import { Button } from '@codegouvfr/react-dsfr/Button';
import Tooltip from '@codegouvfr/react-dsfr/Tooltip';
import React, { PropsWithChildren } from 'react';

export const Panel = ({ title, subtitle, cornerButton, children }: PanelProps) => {
  return (
    <div className={'bg-white px-6 py-8 rounded-lg'}>

      <div className={'flex'}>

        <div className={'flex flex-col flex-1 mb-4'}>

          <h6 style={{ marginBottom: 0 }}>{title}</h6>

          <span className={'color-[#3A3A3A] text-sm mt-1'}>{subtitle}</span>
        </div>

        {(!!cornerButton) && (
          <Tooltip
            title={cornerButton.toolTipMessage ? cornerButton.toolTipMessage : ''}
            kind="hover"
            style={{ display: (cornerButton.toolTipMessage) ? 'unset' : 'none' }}>
            <Button
              iconId={cornerButton.iconId}
              style={{ transform: (cornerButton.rotate90) ? 'rotate(90deg)' : '' }}
              onClick={() => cornerButton?.onClick()}
              disabled={cornerButton.disabled ?? false}
              priority="secondary" />

          </Tooltip>
        )}
      </div>

      {children}
    </div>
  );
};

interface PanelProps extends PropsWithChildren {
  title: string;
  subtitle?: string;
  cornerButton?: CornerButtonConfig;
}

export interface CornerButtonConfig {
  iconId: FrIconClassName;
  onClick: () => void;
  rotate90?: boolean;
  disabled?: boolean;
  toolTipMessage?: string;
}